import { Button, Col, Divider, Input, List, Modal, Row, Select, Table, message } from 'antd';
import { useEffect, useState } from 'react';
import { getCourseManagerList, getCourseList, addCourseManager, delCourseManager } from '@/services/api/bohrium';

interface Manager {
    id: number;
    userId: number;
    userName: string;
    status: number;
    roleType: number;
}

interface Course {
    id: number;
    title: string;
    authors: string;
    startTime: string;
    courseLearnerCount: number;
    courseId: string;
}

export const CourseManager = () => {
    const [visible, setVisible] = useState(false);
    const [data, setData] = useState<Course[]>([]);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [total, setTotal] = useState(0);
    const [managerList, setManagerList] = useState<Manager[]>([]);
    const [curRow, setCurRow] = useState<Course>();
    const [emailOrPhone, setEmailOrPhone] = useState('');
    const [roleType, setRoleType] = useState(2);

    const refresh = (newPage: number = page, newPageSize: number = pageSize) => {
        getCourseList({ page: newPage, pageSize: newPageSize }).then(rep => {
            setData(rep.data?.items || []);
            setTotal(rep.data?.total || 0);
            setPage(newPage ?? page);
            setPageSize(newPageSize ?? pageSize);
        });
    };
    const getManagerList = (courseId: string) => {
        if (!courseId) {
            console.error('curRow is null');
            return;
        }
        getCourseManagerList(courseId).then(rep => {
            if (rep.code === 0) {
                console.log(rep.data.items);
                setManagerList(rep.data.items || []);
            } else {
                message.error(rep.error?.msg || '服务器内部错误');
            }
        });
    };
    useEffect(() => {
        refresh(page, pageSize);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleDelete = (id: number, roleType: number) => {
        delCourseManager([
            {
                courseId: curRow?.courseId || '',
                userId: id,
                emailOrPhone: '',
                roleType,
            },
        ]).then(rep => {
            if (rep.code === 0) {
                message.success('删除成功');
                getManagerList(curRow?.courseId || '');
            } else {
                message.error(rep.error?.msg || '服务器内部错误');
            }
        });
    };
    return (
        <div>
            <Table
                pagination={{
                    defaultPageSize: pageSize,
                    current: page,
                    showSizeChanger: true,
                    onChange: (newPage: number, newPageSize?: number) => {
                        refresh(newPage, newPageSize);
                    },
                    total,
                }}
                dataSource={data}
                rowKey={record => record.id}
                columns={[
                    {
                        title: 'ID',
                        dataIndex: 'id',
                    },
                    {
                        title: '名称',
                        width: 250,
                        dataIndex: 'title',
                    },
                    {
                        title: '作者',
                        width: 150,
                        dataIndex: 'authors',
                    },
                    {
                        title: '开课时间',
                        dataIndex: 'startTime',
                    },
                    {
                        title: '学员数',
                        dataIndex: 'courseLearnerCount',
                    },
                    {
                        title: '课程code',
                        dataIndex: 'courseId',
                    },
                    {
                        title: '操作',
                        width: 100,
                        fixed: 'right',
                        render: (_, row) => (
                            <Button
                                style={{ marginRight: 4 }}
                                type="primary"
                                onClick={() => {
                                    setCurRow(row);
                                    getManagerList(row.courseId);
                                    setVisible(true);
                                }}
                            >
                                管理员
                            </Button>
                        ),
                    },
                ]}
                scroll={{ x: true, y: 'calc(100vh - 230px)' }}
            />
            <Modal
                visible={visible}
                title={curRow?.title}
                footer={null}
                onCancel={() => {
                    setVisible(false);
                    setEmailOrPhone('');
                }}
            >
                <Row justify="space-between" align="middle" style={{ width: '100%' }}>
                    <Col>
                        <Input
                            id="emailOrPhone"
                            placeholder="输入邮箱或手机号"
                            value={emailOrPhone}
                            onChange={e => setEmailOrPhone(e.target.value)}
                        />
                    </Col>
                    <Col>
                        <Select defaultValue={2} style={{ width: 120 }} onChange={value => setRoleType(value)}>
                            <Select.Option value={1}>讲师</Select.Option>
                            <Select.Option value={2}>助教</Select.Option>
                        </Select>
                    </Col>
                    <Col>
                        <Button
                            type="primary"
                            onClick={() => {
                                if (emailOrPhone === '') {
                                    message.error('请输入邮箱或手机号');
                                    return;
                                }
                                if (!curRow || !curRow.courseId) {
                                    message.error('课程数据异常');
                                    return;
                                }
                                addCourseManager([
                                    {
                                        courseId: curRow?.courseId || '',
                                        emailOrPhone: emailOrPhone || '',
                                        userId: 0,
                                        roleType,
                                    },
                                ]).then(rep => {
                                    if (rep.code === 0) {
                                        message.success('添加成功');
                                        getManagerList(curRow?.courseId || '');
                                        setEmailOrPhone('');
                                    } else {
                                        message.error(rep.error?.msg || '服务器内部错误');
                                    }
                                });
                            }}
                        >
                            添加
                        </Button>
                    </Col>
                </Row>
                <Divider>管理员列表</Divider>
                <Row justify="space-between" align="middle" style={{ width: '100%', fontWeight: 'bold' }}>
                    <Col xs={24} sm={12} md={8} lg={6} xl={4}>
                        用户id
                    </Col>
                    <Col xs={28} sm={14} md={10} lg={8} xl={6}>
                        用户名
                    </Col>
                    <Col xs={20} sm={10} md={6} lg={4} xl={2}>
                        身份
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={6} xl={4}>
                        状态
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={6} xl={4}>
                        操作
                    </Col>
                </Row>
                <List
                    dataSource={managerList}
                    renderItem={item => (
                        <List.Item key={item.userId}>
                            <Row justify="space-between" align="middle" style={{ width: '100%' }}>
                                <Col xs={24} sm={12} md={8} lg={6} xl={4}>
                                    {item.userId}
                                </Col>
                                <Col xs={28} sm={14} md={10} lg={8} xl={6}>
                                    {item.userName}
                                </Col>
                                <Col xs={20} sm={10} md={6} lg={4} xl={2}>
                                    {''}
                                    {(() => {
                                        if (item.roleType === 1) {
                                            return '讲师';
                                        }
                                        if (item.roleType === 2) {
                                            return '助教';
                                        }
                                        return `未知-${item.roleType}`;
                                    })()}
                                </Col>
                                <Col xs={24} sm={12} md={8} lg={6} xl={4}>
                                    {''}
                                    {(() => {
                                        if (item.status === 1) {
                                            return '有效';
                                        }
                                        if (item.status === 2) {
                                            return '已删除';
                                        }
                                        return `未知-${item.status}`;
                                    })()}
                                </Col>
                                <Col xs={24} sm={12} md={8} lg={6} xl={4}>
                                    {item.status === 1 && (
                                        <Button onClick={() => handleDelete(item.userId, item.roleType)}> 删除 </Button>
                                    )}
                                </Col>
                            </Row>
                        </List.Item>
                    )}
                />
            </Modal>
        </div>
    );
};
